export const environment = {
  production: false,
  api_host: 'https://tn7uusu7d4.execute-api.us-west-1.amazonaws.com/api/v1/',
  chat_url: 'wss://1zylu1o7vi.execute-api.us-west-1.amazonaws.com/dev',
  stripe_publishable_key:
    'pk_test_51RIeB2P3Pyx4VK0oaDAzUiHwEosmx579tvmFvo5RrSO7UjbmHXyYwqQ82Bon8f6W7kNXUj8wIc87pgAz6yOaxEYl00G8a15v3M',
  // Soketi configuration for dev
  soketi_app_key: 'qWeVLJeQZ3E747WCk89UP3pK',
  soketi_host: 'dev.websocket.longhealth.io',
  soketi_port: '443',
  syncfusionDocumentEditorServiceUrl:
    'https://n13u529b11.execute-api.us-west-1.amazonaws.com/api/documenteditor/',
  enableDocxEditorTestRoute: false,
  // Maintenance mode flag (set to true to enable maintenance page)
  maintenance: false,
  // When true, AuthGuard routes "no active subscription" to /payment; when
  // false, it routes to the generic access-fallback screen instead.
  showPaymentFallback: true,
  // When true, records in Review of Records can be edited inline.
  reviewOfRecordsEditsEnabled: false,
  qmeVoiceEditEnabled: true,
  // Minutes without mouse, keyboard, scroll or touch activity before the
  // "Session about to expire" dialog opens; logout follows after a further
  // 2-minute countdown. Must be above 0 and at most 60, otherwise 15 is used.
  inactivityTimeoutMinutes: 30,
};
